import './landing.scss';
import template from './landing.html';
import servicioTemplate from './servicio.html';
import { LoginActions } from 'core/services/login';
import { NavigationActions } from 'core/services/navigation';
import commonI18N from 'i18n/common/es.json';
import turnosI18N from 'i18n/turnos/es.json';
import { rest } from 'core/api';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { pad, daysOfWeekMapHorarios, daysOfWeekMapHabilitados, horarios, horas, minutos, fechaHoraRenderer, isObjectEmpty, renderEspecialistaTabla } from 'core/util';
//import ordenesI18N from 'i18n/ordenes/es.json';


pdfMake.vfs = pdfFonts.pdfMake.vfs;


// MODULE EXPORTS
export let LandingComponent = {
  templateUrl: template,
  selector: 'landing',
  bindings: {
    translations: '='
  },
  controller: LandingCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(commonI18N).concat(turnosI18N);

let actions = Object.assign({}, LoginActions);
actions = Object.assign(actions, NavigationActions);

LandingCtrl.$inject = ['$ngRedux', '$state', 'ngNotify', 'Filter', '$timeout', '$q', '$window', 'BasicFactory', 'AuthorizationService', 'CustomModal', '$compile', '$scope'];

function LandingCtrl($ngRedux, $state, ngNotify, Filter, $timeout, $q, $window, BasicFactory, AuthorizationService, CustomModal, $compile, $scope) {
  Object.assign(this, { $ngRedux, $state });
  this.mapStateToThis = mapStateToThis.bind(this);

  const parametroFilter = Filter.path('codigo').eq('inicio_agenda_diaria').or(Filter.path('codigo').eq('fin_agenda_diaria'));

  var defaultColumnOrder = ['servicio.nombre', 'especialista.nombre', 'especialista.nombre', 'especialista.apellido',
  'fechaInicio', 'cita.cliente.nombre', 'cita.cliente.apellido', 'cita.cliente.telefono'];
  var staticFilter = Filter.path('fechaInicio').gte(new Date()).and(Filter.path('especialista.recordatorio').eq(true).or(
    Filter.path('cita.recordatorio').eq(true)).and(Filter.path('cita.estado.value').eq('No Confirmada')));


  this.optionsCitasConRecordatorio = {
    staticFilter,
    resource: 'cita-detalles',
    hideHeader: true,
    hasOptions: true,
    // detailRows: [
    //   { data: 'codigo', title: this.translations['Código'] },
    //   { data: 'servicio.nombre', title: this.translations['Servicio'] }
    // ],
    dom: 'rtip',
    drawCallback: function(oSettings) {
      if (oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
        $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
      }
    },
    title: this.translations['Listado de ordenes'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'servicio.nombre', title: this.translations['Servicio'] },
      { data: 'especialista.nombre', title: this.translations['Nombre Especialista'] },
      { data: 'especialista.apellido', title: this.translations['Apellido Especialista'] },
      { data: 'fechaInicio', title: this.translations['Fecha'], renderWith: fechaHoraRenderer },
      {
        data: 'cita.cliente.nombre',
        title: this.translations['Nombre Cliente'],
        render: function(data, type, row) {
          return row.cabecera.cliente.nombre ? row.cabecera.cliente.nombre : '<i>No establecido</i>';
        }
      },
      {
        data: 'cita.cliente.apellido',
        title: this.translations['Apellido Cliente'],
        render: function(data, type, row) {
          return row.cabecera.cliente.apellido ? row.cabecera.cliente.apellido : '<i>No establecido</i>';
        }
      },
      {
        data: 'cita.cliente.telefono',
        title: this.translations['Teléfono Cliente'],
        render: function(data, type, row) {
          return row.cabecera.cliente.telefono ? row.cabecera.cliente.telefono : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 1,
    defaultOrderDir: 'asc',
    canListCondition: () => { false; },
    canEditCondition: () => { false; },
    canRemoveCondition: () => { false; },
    canConfirmar: canConfirmar.bind(this),
    extraRowOptions: [{
      templateToRender: '<div style="text-align:center;"><button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="Confirmar" ng-show="options.canConfirmar(rowsData[<%= dataId %>])" ng-click="confirmarCita(rowsData[<%= dataId %>])">Confirmar</button></div>',
      functionName: 'confirmarCita',
      functionDef: (itemId) => {

        let self = this;
        CustomModal.open({
          title: 'Confirmar',
          id: itemId,
          message: '¿Desea confirmar la Cita?',
          ok: function() {
            $ngRedux.dispatch(rest.actions.confirmarCita({ id: itemId.cabecera.id }, {
              body: JSON.stringify({})
            }, (err, data) => {
              if (!err && data.estado.value == 'Confirmada') {
                ngNotify.set(self.translations['Confirmada Correctamente'], 'success');
                self.optionsCitasConRecordatorio.reloadData();
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
          }
        });
      }
    }]
  };

  function canConfirmar(data) {
    return (data.cabecera.estado.value === 'No Confirmada') && AuthorizationService.hasPermission('update_citas');
  }


  let unsubscribe;

  this.$onDestroy = () => {
    $ngRedux.dispatch(rest.actions.categoriasProductos.reset());
    $ngRedux.dispatch(rest.actions.parametros.reset());
    $ngRedux.dispatch(rest.actions.clientesCumpleanhos.reset());
    unsubscribe();
  };

  this.localModel = {
    day: moment().format('DD/MM/YYYY'),
    fecha: new Date(),
    cita: {
      actual: {},
      excepcion: {},
      detalles: []
    }
  };

  this.formatAgenda = 'fullDate';
  const categoriaFilter = Filter.path('clase.value').eq('Servicio');

  this.onChangeDate = onChangeDate.bind(this);

  function onChangeDate() {
    this.localModel.day = moment(this.localModel.fecha).format('DD/MM/YYYY');
    this.loadTable();
  }

  this.toggleFullscreenAgenda = toggleFullscreenAgenda.bind(this);

  function toggleFullscreenAgenda() {
    // $timeout(() => {
    //   angular.element('#fullscreen-btn-hidden-agenda').click();
    // });
    let element = document.getElementById('panel-agenda');

    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (element.requestFullScreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
      this.fullscreen = true;
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      this.fullscreen = false;
    }
  }

  this.registrarTurno = registrarTurno.bind(this);

  function registrarTurno() {
    $state.go('home.turnos.new', {next : 'home.landing'});
  }

  this.changeDateNext = changeDateNext.bind(this);

  function changeDateNext() {
    let date = moment(this.localModel.day, 'DD/MM/YYYY').add(1, 'days');
    this.localModel.fecha = date.toDate();
    this.onChangeDate();
  }


  this.changeDatePrev = changeDatePrev.bind(this);

  function changeDatePrev() {
    let date = moment(this.localModel.day, 'DD/MM/YYYY').add(-1, 'days');
    this.localModel.fecha = date.toDate();
    this.onChangeDate();
  }


  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, actions)(this);
    $ngRedux.dispatch(rest.actions.categoriasProductos({ filter: JSON.stringify(categoriaFilter) }));
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
    $ngRedux.dispatch(rest.actions.clientesCumpleanhos({}));
    this.loadTable();
    let self = this;

    $('.agenda').scroll(function() {
      $(this).find('.sticky').css('left', $(this).scrollLeft());
    });

    $('.agenda').scroll(function() {
      self.checkTop(this, self);
    });

    $('#page-content').scroll(function() {
      self.checkTop($('.agenda'), self);
    });

    self.canCrearCita = AuthorizationService.hasPermission('create_citas');
    self.canUpdateCita = AuthorizationService.hasPermission('update_citas');
    self.canCreateTurno = AuthorizationService.hasPermission('create_turnos');

    if (!self.canCreateTurno) {
      $timeout(function() {
        self.canCrearCita = AuthorizationService.hasPermission('create_citas');
        self.canUpdateCita = AuthorizationService.hasPermission('update_citas');
        self.canCreateTurno = AuthorizationService.hasPermission('create_turnos');
      }, 1400);
    }



  };

  this.checkTop = checkTop.bind(this);

  function checkTop(element, self) {
    let top = $(element).scrollTop() - 197;
    if (self.fullscreen) {
      top += 30;
    } else if ($('#page-content').scrollTop() > 360) {
      top += ($('#page-content').scrollTop() - 360);
    }

    $(element).find('.sticky-top').css('top', top > 0 ? top : 0);
  }

  this.$postLink = () => {
    $timeout(() => $('.fecha-agenda input').prop('disabled', true));
  };


  this.loadTable = loadTable.bind(this);

  function loadTable() {
    this.loading = true;
    let payload = {
      day: this.localModel.day
    };

    if (this.categoria) {
      payload.categoriaServicioId = this.categoria.id;
    } else {
      this.loading = false;
      return;
    }

    angular.element('.loader-page').show();
    angular.element('body').addClass('loading');
    Pace.restart();
    let self = this;
    $ngRedux.dispatch(rest.actions.agendaDiaria({}, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err) {

        let allCitas = [];
        let chunk = data.length;
        for (let i = 0, j = data.length; i < j; i += chunk) {
          let temp = data.slice(i, i + chunk);
          allCitas.push(temp);
          for (let index = 0; index < temp.length; index++) {
            self.mapDisponibilidad(temp[index].especialista, self.localModel.day, temp[index].excepciones);
          }
        }
        if (!data.length) {
          self.conEventos = false;
        } else {
          let disponibles = data.filter(e => self.disponibilidad[e.especialista.id].disponible);
          self.conEventos = disponibles ? disponibles.length > 0 : false;
        }
        self.loading = false;
        self.allCitas = allCitas;
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }

  function mapStateToThis(state) {
    if (state.parametros.data && state.parametros.data.length) {
      let inicio = state.parametros.data.filter((v) => v.codigo === 'inicio_agenda_diaria')[0];
      let fin = state.parametros.data.filter((v) => v.codigo === 'fin_agenda_diaria')[0];

      if (inicio) {
        this.inicio = inicio.valor.value;
      }

      if (fin) {
        this.fin = fin.valor.value;
      }
    }

    if (!state.clientesCumpleanhos.loading && state.clientesCumpleanhos.data && state.clientesCumpleanhos.data.length > 0 && !this.localModel.clientesCumpleanhos) {
      this.loadingClientesCumpleanhos = false;
      this.sinResultadosClientesCumpleanhos = false;
      this.localModel.clientesCumpleanhos = state.clientesCumpleanhos.data;
    }

    if (state.clientesCumpleanhos.data && state.clientesCumpleanhos.data.length === 0) {
      this.loadingClientesCumpleanhos = false;
      this.sinResultadosClientesCumpleanhos = true;
    }

    if (state.currentUser) {
      this.setNodes();
    }

    return {
      login: state.login,
      navigation: state.navigation,
      categorias: state.categoriasProductos.data
    };
  }

  this.setNodes = setNodes.bind(this);

  function setNodes() {
    this.enlaces = [];
    if (AuthorizationService.hasPermission('index_clientes')) {
      this.enlaces.push({
        title: 'Clientes',
        state: 'home.clientes.list',
        classButton: 'btn-black',
        classIcon: 'icon-users'
          // badge: 1
      });
    }

    if (AuthorizationService.hasPermission('index_clientes')) {
      this.enlaces.push({
        title: 'Cajas',
        state: 'home.cajas.list',
        classButton: 'btn-danger',
        classIcon: 'icon-print'
      });
    }

    if (AuthorizationService.hasPermission('index_citas')) {
      this.enlaces.push({
        title: 'Citas',
        state: 'home.citas.list',
        classButton: 'btn-primary',
        classIcon: 'icon-th'
      });
    }

    if (AuthorizationService.hasPermission('index_orden_trabajo')) {
      this.enlaces.push({
        title: 'Órdenes de Trabajo',
        state: 'home.ordenes.list',
        classButton: 'btn-warning',
        classIcon: 'icon-th-large'
      });
    }

    if (AuthorizationService.hasPermission('index_facturas')) {
      this.enlaces.push({
        title: 'Facturas',
        state: 'home.facturas.list',
        classButton: 'btn-danger',
        classIcon: 'icon-money'
      });
    }

    if (AuthorizationService.hasPermission('index_productos')) {
      this.enlaces.push({
        title: 'Productos',
        state: 'home.productos.list',
        classButton: 'btn-yellow',
        classIcon: 'icon-cube'
      });
    }

    if (AuthorizationService.hasPermission('tablero_trabajo')) {
      this.enlaces.push({
        title: 'Tablero de Trabajo',
        state: 'tablero-trabajo',
        classButton: 'btn-success',
        classIcon: 'icon-th-list',
      });
    }

    if (AuthorizationService.hasPermission('tablero_especialistas')) {
      this.enlaces.push({
        title: 'Tablero de Especialistas',
        state: 'tablero-especialistas',
        classButton: 'btn-info',
        classIcon: 'icon-list-ul'
      });
    }

    if (AuthorizationService.hasPermission('tablero_turnos')) {
      this.enlaces.push({
        title: 'Tablero de Turnos',
        state: 'tablero-turnos',
        classButton: 'btn-purple',
        classIcon: 'icon-th-list',
      });
    }

    if (AuthorizationService.hasPermission('tablero_comisiones')) {
      this.enlaces.push({
        title: 'Tablero de Comisiones',
        state: 'tablero-comisiones',
        classButton: 'btn-info',
        classIcon: 'icon-align-right'
      });
    }

    if (AuthorizationService.hasPermission('tablero_clientes')) {
      this.enlaces.push({
        title: 'Tablero de Clientes',
        state: 'tablero-clientes',
        classButton: 'btn-warning',
        classIcon: 'icon-users'
      });
    }

    // if (AuthorizationService.hasPermission('index_estadisticas')) {
    //   this.enlaces.push({
    //     title: 'Estadisticas',
    //     state: 'home.estadisticas.list',
    //     classButton: 'btn-blue-alt',
    //     classIcon: 'icon-bar-chart'
    //   });
    // }

    if (AuthorizationService.hasPermission('index_facturas')) {
      this.enlaces.push({
        title: 'Nueva Factura',
        state: 'home.facturas.new',
        classButton: 'btn-danger',
        classIcon: 'icon-money'
      });
    }

  }

  this.selectCategoria = selectCategoria.bind(this);

  function selectCategoria() {
    this.loadTable();
  }


  this.horarioLaboral = horarioLaboral.bind(this);

  function horarioLaboral(hora) {
    if (hora >= this.inicio && hora <= this.fin) {
      return 'horario-laboral';
    } else {
      return 'horario-no-laboral';
    }
  }


  this.puedeContinuacion = puedeContinuacion.bind(this);

  function puedeContinuacion(diaEspecialista, hora, minuto) {

    if (diaEspecialista.clientes[hora + ':' + minuto.valor] && diaEspecialista.clientes[hora + ':' + minuto.valor].continuacion) {
      for (let i = 0; i < minuto.solapados.length; i++) {
        if (diaEspecialista.clientes[hora + ':' + minuto.solapados[i]] && diaEspecialista.clientes[hora + ':' + minuto.solapados[i]].cliente) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  this.puedeCrear = puedeCrear.bind(this);

  function puedeCrear(diaEspecialista, hora, minuto) {
    for (let i = 0; i < minuto.solapados.length; i++) {
      if (diaEspecialista.clientes[hora + ':' + minuto.solapados[i]] && !diaEspecialista.clientes[hora + ':' + minuto.solapados[i]].cancelada) {
        return false;
      }
    }

    if (this.disponibilidad[diaEspecialista.especialista.id][hora + ':' + minuto.valor] && this.disponibilidad[diaEspecialista.especialista.id].disponible) {
      return true;
    }

    return false;
  }

  this.clearCategoria = clearCategoria.bind(this);

  function clearCategoria() {
    this.conEventos = false;
    this.categoria = null;
    this.loadTable();
  }

  this.confirmar = confirmar.bind(this);

  function confirmar(cita) {
    let self = this;
    $ngRedux.dispatch(rest.actions.confirmarCita({ id: cita.id }, {
      body: JSON.stringify({})
    }, (err, data) => {
      if (!err && data.estado.value == 'Confirmada') {
        cita.estado = data.estado.value;
        self.optionsCitasConRecordatorio.reloadData();
      } else if (err) {
        ngNotify.set(err.message, 'warn');
        self.selectCategoria();
      }
    }));
  }

  this.cancelar = cancelar.bind(this);

  function cancelar(cita) {
    let self = this;
    $ngRedux.dispatch(rest.actions.cancelarCita({ id: cita.id }, {
      body: JSON.stringify({})
    }, (err, data) => {
      if (!err && data.estado.value == 'Cancelada') {
        delete cita.cliente;
        cita.cancelada = true;
        self.loadTable();

        self.optionsCitasConRecordatorio.reloadData();
      } else if (err) {
        ngNotify.set(err.message, 'warn');
        self.selectCategoria();
      }
    }));
  }


  this.concretar = concretar.bind(this);

  function concretar(cita) {
    let self = this;
    $ngRedux.dispatch(rest.actions.concretarCita({ id: cita.id }, {
      body: JSON.stringify({})
    }, (err, data) => {
      if (!err && data.estado.value == 'Concretada') {
        cita.estado = data.estado.value;
        self.optionsCitasConRecordatorio.reloadData();
      } else if (err) {
        ngNotify.set(err.message, 'warn');
        self.selectCategoria();
      }
    }));
  }


  this.horarios = horarios;
  this.minutos = minutos;

  this.imprimir = imprimir.bind(this);

  function imprimir() {
    $window.print();
  }

  this.getClassName = getClassName.bind(this);

  function getClassName(estado) {
    if (estado === 'No Confirmada') {
      return 'label-warning';
    } else if (estado === 'Confirmada') {
      return 'label-primary';
    } else if (estado === 'Concretada') {
      return 'label-purple';
    } else if (estado === 'Turno') {
      return 'label-info';
    } else if (estado === 'Adicional') {
      return 'label-yellow';
    }
  }

  this.bajarPdf = bajarPdf.bind(this);

  function bajarPdf() {

    angular.element('.loader-page').show();
    angular.element('body').addClass('loading');
    Pace.restart();
    $('body').scrollTop(0);
    let self = this;
    $timeout(function() {
      self.crearPdf();
    }, 0);

  }

  this.crearPdf = crearPdf.bind(this);

  function crearPdf() {
    // create canvas object
    function getCanvas(form) {
      return html2canvas(form, {
        imageTimeout: 1000,
        removeContainer: false
      });
    }
    let chunks = this.allCitas.length;
    let canvas = [];
    for (let i = 0; i < chunks; i++) {
      canvas.push(getCanvas($(`#agenda${i}`)));
    }

    $q.all(canvas)
      .then(function(dataResolved) {
        var content = [];

        for (let i = 0; i < chunks; i++) {
          let agenda = dataResolved[i].toDataURL();
          content.push({
            image: agenda,
            width: 500
          });
        }

        var docDefinition = {
          info: {
            title: `Citas del ${moment().format('DD/MM/YYYY')}`,
            author: 'diibSer'
          },
          content
        };
        pdfMake.createPdf(docDefinition).download(`citas_${moment().format('DD-MM-YYYY')}.pdf`);
      });
  }



  this.renderNumero = renderNumero.bind(this);

  function renderNumero(cita) {
    if (cita.estado === 'Adicional')
      return 'Adicional agregado a orden';
    else if (cita.estado === 'Turno')
      return 'Turno';
    else
      return `Cita Nro: ${cita.num}`;
  }

  this.disponibilidad = {};

  function formatHorario(hora) {
    return `${pad(~~(hora/2), 2)}:${hora%2 ? '30' : '00'}`;
  }

  this.mapDisponibilidad = mapDisponibilidad.bind(this);

  function mapDisponibilidad(empleado, day, excepciones) {
    let self = this;
    let date = moment(day, 'DD/MM/YYYY');
    var weekDayName = date.format('dddd');
    let dayOfWeek = date.day();
    let horarios = empleado.disponibilidad[daysOfWeekMapHorarios[dayOfWeek]];
    let rangos = [];
    let disponiblesMap = {};

    disponiblesMap.disponible = empleado.disponibilidad[daysOfWeekMapHabilitados[dayOfWeek]];

    if (excepciones.length) {
      excepciones.forEach(function(excepcion) {
        if (excepcion.rangoHorario) {
          Object.keys(excepcion.horarios).forEach(function(key) {
            self.localModel.cita.excepcion[key] = excepcion.observaciones;
          });
        } else {
          disponiblesMap.disponible = false;
        }
      });
    }

    horarios.forEach(function(rango) {
      if (rango.inicio !== rango.fin) {
        for (let i = rango.inicio; i < rango.fin; i++) {
          let disponible = formatHorario(i);
          disponiblesMap[disponible] = true;
        }

        let desde = formatHorario(rango.inicio);
        let hasta = formatHorario(rango.fin);

        rangos.push(`De ${desde} hs. a ${hasta} hs.`);
      }
    });

    disponiblesMap.tooltip = `${weekDayName}: ${empleado.disponibilidad[daysOfWeekMapHabilitados[dayOfWeek]] ? rangos.join(' - '): 'No Disponible'}`;

    this.disponibilidad[empleado.id] = disponiblesMap;
  }

  this.renderServicio = renderServicio.bind(this);

  function renderServicio(item) {
    return `${item.nombre}`;
  }

  this.loadServicios = loadServicios.bind(this);
  function loadServicios(query, empleado) {
    if (!empleado) return;

    let especialidades = [];
    empleado.especialidades.forEach(function(especialidad) {
      especialidades.push(especialidad.id);
    });

    let filter = Filter.path('activo').eq(true)
      .and(Filter.path('estado.value').eq('Activo'))
      .and(Filter.path('categoria.clase.value').eq('Servicio'))
      .and(Filter.path('especialidades.id').in(especialidades))
      .and(Filter.path('servicioPadre.id').isNull());

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.filterServicio = filterServicio.bind(this);
  function filterServicio(servicio) {
    return servicio.precio;
  }

  this.isObjectEmpty = isObjectEmpty.bind(this);

  this.irCitas = irCitas.bind(this);

  function irCitas() {
    let params = { next : 'home.landing', detalles: this.localModel.cita.detalles};
    $state.go('home.citas.new', params);
  }

  function stringHourGte(hora1, hora2) {
    return hora1.localeCompare(hora2) > 0;
  }

  function stringCompare(a, b) {
    return a.localeCompare(b);
  }

  this.nuevaCita = nuevaCita.bind(this);
  function nuevaCita(hora, minuto, especialista) {
    // Al abrir el modal de agregar cita:

    // ver cual es la primera hora (slot) ocupada luego del inicio de la cita siendo creada
    const horaInicio = hora + ':' + minuto;
    const allCitasEspecialista = this.allCitas[0].find(cita => cita.especialista.id === especialista.id);
    const horasCitasEspecialista = allCitasEspecialista && allCitasEspecialista.clientes && Object.keys(allCitasEspecialista.clientes);
    const sgteHoraCita = horasCitasEspecialista.filter(horaCita => stringHourGte(horaCita, horaInicio)).sort(stringCompare)[0];

    // ver cual es la primera hora (slot) con excepcion luego del inicio de la cita siendo creada
    const sgteHoraExcepcion = allCitasEspecialista
      .excepciones
      .map(excepcion => (excepcion.horario && excepcion.horario.rangos && excepcion.horario.rangos.map(rango => rango.inicio)) || [])
      .flat()
      .filter(horaExcepcion => stringHourGte(horaExcepcion, horaInicio))
      .sort(stringCompare)[0];

    this.localModel.duracionWarning = null;

    if (this.fullscreen) {
      this.toggleFullscreenAgenda();
    }

    let self = this;
    let fecha = this.localModel.day + ' ' + hora + ':' + minuto;
    let fechaSgteHoraCita = this.localModel.day + ' ' + sgteHoraCita;
    let fechaSgteHoraExcepcion = this.localModel.day + ' ' + sgteHoraExcepcion;


    this.localModel.especialista = especialista;
    this.localModel.payload = {
      duracion: 30,
      especialista,
      fechaInicio: fecha,
      excepcion: false
    };

    $ngRedux.dispatch(rest.actions.verificarDisponibilidad({}, {
      body: JSON.stringify({
        especialistaId: especialista.id,
        fechaInicio: fecha
      })
    }, (err, data) => {
      if (!err) {
        CustomModal.open({
          title: 'Citas y Disponibilidades',
          size: 'lg',
          //message: `Con ${especialista.nombre} ${especialista.apellido}, el ${this.localModel.day} a las ${horario}`,
          templateUrl: servicioTemplate,
          vm: self,
          especialista,
          renderServicio,
          renderEspecialistaTabla,
          fecha,
          selectExcepcion: (payload) => {
            payload.excepcion = true;
          },
          selectCita: (payload) => {
            payload.excepcion = false;
          },
          payload: self.localModel.payload,
          onChangeDuracion: () => {
            let duracion = self.localModel.payload.duracion;
            let fechaInicio = self.localModel.payload.fechaInicio;
            let fechaFinUnix = moment(fechaInicio, 'DD/MM/YYYY HH:mm').add(duracion, 'm').unix();
            let fechaSgteHoraCitaUnix = moment(fechaSgteHoraCita, 'DD/MM/YYYY HH:mm').unix();
            let fechaSgteHoraExcepcionUnix = moment(fechaSgteHoraExcepcion, 'DD/MM/YYYY HH:mm').unix();
            let horaLimite = moment('23:00', 'HH:mm');
            let fechaLimiteUnix = moment(fechaInicio, 'DD/MM/YYYY HH:mm').set({
              hour:   horaLimite.get('hour'),
              minute: horaLimite.get('minute')
            }).unix();

            // console.table([
            //   ['fechaFinUnix', moment.unix(fechaFinUnix).format("MM/DD/YYYY HH:mm")],
            //   ['fechaSgteHoraCitaUnix', moment.unix(fechaSgteHoraCitaUnix).format("MM/DD/YYYY HH:mm")],
            //   ['fechaSgteHoraExcepcionUnix', moment.unix(fechaSgteHoraExcepcionUnix).format("MM/DD/YYYY HH:mm")],
            //   ['fechaLimiteUnix', moment.unix(fechaLimiteUnix).format("MM/DD/YYYY HH:mm")],
            // ]);

            // Si existe una cita posterior a la que se esta creando, verificar que no se solape
            if (sgteHoraCita && fechaFinUnix > fechaSgteHoraCitaUnix) {
              self.localModel.duracionWarning = 'La cita se solapa con una posterior';
            } else if (sgteHoraExcepcion && fechaFinUnix > fechaSgteHoraExcepcionUnix) {
              // Si existe una excepción posterior a la que se esta creando, verificar que no se solape
              self.localModel.duracionWarning = 'La cita se solapa con una excepción';
            } else if (fechaFinUnix > fechaLimiteUnix) {
              // Verificar que no ponga una duracion muy larga accidentalmente
              self.localModel.duracionWarning = 'La duración parece muy grande, está seguro?';
            } else {
              self.localModel.duracionWarning = null;
            }
          },
          actionLeft: (cancel) => {
            if (!self.localModel.payload.servicio) return false;
            if (!self.localModel.payload.duracion) return false;
            let detalle = Object.assign({}, this.localModel.payload);
            this.localModel.cita.detalles.push(detalle);
            this.irCitas();
            cancel();
          },
          actionLabel: 'Agregar a Cita y Continuar',
          actionLeftLabel: 'Agregar e Ir a Citas',
          deleteDetalle: (detalle) => {
            _.remove(self.localModel.cita.detalles, detalle);
            marcarCuadros(self.localModel.cita.actual, detalle.hora, detalle.minuto, self.localModel.day, detalle.duracion, detalle.especialista, false);
          },
          ok: () => {
            if (!self.localModel.payload.servicio && !self.localModel.payload.excepcion) return false;
            if (!self.localModel.payload.observaciones && self.localModel.payload.excepcion) return false;

            if (!self.localModel.payload.duracion) return false;
            let mapToCheck = self.localModel.cita.actual;

            if (self.localModel.payload.excepcion) {
              mapToCheck = self.localModel.cita.excepcion;
              let horarios = marcarCuadros(mapToCheck, hora, minuto, self.localModel.day, self.localModel.payload.duracion, especialista, self.localModel.payload.observaciones);

              let payload = {
                horarios,
                empleadoId: especialista.id,
                rangoHorario: true,
                habilitado: false,
                observaciones: self.localModel.payload.observaciones,
                fecha,
                duracion: self.localModel.payload.duracion
              };

              $ngRedux.dispatch(rest.actions.excepcionDisponibilidad.post({}, {
                body: JSON.stringify(payload)
              }, (err, data) => {
                if (!err && data) {
                } else if (err) {
                  marcarCuadros(mapToCheck, hora, minuto, self.localModel.day, self.localModel.payload.duracion, especialista, false);
                  ngNotify.set(err.message, 'warn');
                }
              }));
            } else {
              let detalle = Object.assign({}, self.localModel.payload);
              detalle.hora = hora;
              detalle.minuto = minuto;
              self.localModel.cita.detalles.push(detalle);
              marcarCuadros(mapToCheck, hora, minuto, self.localModel.day, self.localModel.payload.duracion, especialista, true);
            }
          }
        });
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }
}

function marcarCuadros(mapToCheck, hora, minuto, day, duracion, especialista, check) {
  let cuadros = duracion / 30;
  let horarios = {};
  if (cuadros >= 1) {
    let currentMinuto = minuto;
    let currentHoraIndex = horas.findIndex(e => e === hora);
    for (let i = 0; i < cuadros; i++) {
      horarios[day + ' ' + horas[currentHoraIndex] + ':' + currentMinuto + especialista.id] = check;
      mapToCheck[day + ' ' + horas[currentHoraIndex] + ':' + currentMinuto + especialista.id] = check;
      if (currentMinuto === '30') {
        currentMinuto = '00';
        currentHoraIndex++;
      } else {
        currentMinuto = '30';
      }
    }
  }
  return horarios;
}



// WEBPACK FOOTER //
// ./src/components/landing/landing.component.js